<template>
	<div class="engagement-wrapper">
		<EngagementList :event-list="eventList"></EngagementList>
		<div class="engagement-body">
			<Event
					v-for="event in eventList"
					:event="event"
					:id="event.id"
					:key="event.id">
			</Event>
		</div>
	</div>
</template>

<script>
import EngagementList from './list/List'
import Event from './event/Event'
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
	name: 'engagement',
	watch: {
		$route: function(to, from) {
			if (to.hash) location.hash = to.hash
		},
		eventIds: {
			immediate: true,
			handler(newEventIds) {
				if(newEventIds.length > 0) {
					this.loadContent({
						type: 'event',
						id: newEventIds
					})
				}
			}
		}
	},
	methods: {
		...mapActions('content', ['loadContent'])
	},
	computed: {
		...mapState('content', ['loading']),
		...mapGetters('provider',['getProviderProfile']),
		...mapGetters('content', ['getContent']),
		eventIds() {
			const profile = this.getProviderProfile(this.$route.params.profileId)
			if(profile) {
				return profile.event
			}
			return []
		},
		eventList() {
			return this.getContent('event', this.eventIds)
		}
	},
	components: {
		EngagementList,
		Event
	}
}
</script>

<style scoped>
	* {
		scroll-behavior: smooth;
	}
	.engagement-wrapper{
		display: flex;
	}
	.engagement-body{
		flex-grow: 1;
		border-left: 1px solid #cccccc;
		overflow-y: scroll;
	}
</style>
